import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExtButton } from 'src/components';
import {
  useActiveBrowser,
  useExtension,
  useFeedbackReviewMutation,
  useGetFeedback,
} from 'src/hooks';
import type { TReviewFormState } from 'src/types';
import { extensionsList } from 'src/utils';

type Props = {
  setReviewFormState: React.Dispatch<React.SetStateAction<TReviewFormState>>;
  cartId: string;
};

export const FeedbackModalHappy = ({ setReviewFormState, cartId }: Props) => {
  const { mutate } = useFeedbackReviewMutation(setReviewFormState, cartId);
  const { hideReviewCTA } = useGetFeedback();
  const { extExists } = useExtension();
  const activeBrowser = useActiveBrowser();
  const { t } = useTranslation();

  const currentExtension =
    extensionsList.find((ext) => ext.name === activeBrowser) || extensionsList[0];

  const showDownload = !extExists;

  return (
    <div className='flex w-full max-w-[400px] flex-col items-center justify-center gap-4'>
      <img
        src='https://assets.share-a-cart.com/images/next/dwight-thank-you.gif'
        width='150px'
        height='125px'
        alt='Thank you GIF'
        className='rounded-[32px]'
      />
      <h3 className='text-center font-primary text-2xl font-bold text-primary-dark'>
        {showDownload ? t('get.thats_great') : t('get.you_rock')}
      </h3>
      <p className='text-200 text-center'>
        {showDownload ? (
          <Trans
            i18nKey='get.next_time_try_our_browser_ext'
            context={'react'}
            components={{
              a: (
                <Link
                  to={`/supported`}
                  target='_blank'
                  reloadDocument
                  className='text-primary underline transition hover:text-primary-hover'
                ></Link>
              ),
            }}
          />
        ) : (
          t('get.please_let_the_world_know_what_you_think_of_sac')
        )}
      </p>
      <div className='flex w-full flex-col items-center justify-center gap-6'>
        {showDownload ? (
          <div
            onClick={() => {
              hideReviewCTA('downloaded');
              setReviewFormState('thanks-download');
            }}
          >
            <ExtButton details={currentExtension} primary={true} />
          </div>
        ) : (
          <Link
            onClick={() => mutate({ reaction: 'happy', data: undefined })}
            to={currentExtension.reviewLink}
            target='_blank'
            className='button-primary h-12 w-full gap-2 text-center font-secondary text-base font-bold text-offWhite'
          >
            {t('get.leave_us_a_review')}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-5 w-5'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth={2}
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
              />
            </svg>
          </Link>
        )}
      </div>
    </div>
  );
};
